import React, { Component } from 'react'
import Link from 'gatsby-link'
import { Button, Container, Form, Grid, Header, Modal, Responsive, Segment } from 'semantic-ui-react'
import validator from 'validator'
import { debounce, find, trim, cloneDeep } from 'lodash'

import PageColumn from '../components/PageColumn'

import '../styles/semantic.css'
import '../styles/site.scss'
import './contact.scss'


const error_style = { fontStyle: 'italic' }
const ContactLabel = ({ label, valid, error }) => (
  <label>{label} {valid ? '' : <span style={error_style}>{error}</span>}</label>
)


// const about_form_options = [
//   { value: 'believer', text: "I'm a uniform believer." },
//   { value: 'intrigued', text: "I'm intrigued by uniforms and capsule closets." },
//   { value: 'reporter', text: "I'm a curious reporter." },
//   { value: 'curious', text: "I'm just curious." }
// ]

const default_field_state = {
  value: '',
  valid: true,
  error: ''
}

const default_form_state = {
  valid: true,
  submitting: false,
  submitted: false,
  showError: false,
  errorText: '',
  fields: {
    // name: { ...default_field_state },
    email: { ...default_field_state },
    // option: { ...default_field_state },
  }
}

class ContactForm extends Component {
  state = cloneDeep(default_form_state)

  handleChange = (e, { name, value }) => {
    const fields = { ...this.state.fields }
    fields[name].value = value

    this.setState({ fields })
    this.updateValidity();
  }

  updateValidity = debounce(() => {
    const fields = { ...this.state.fields }

    // const name = fields.name
    // this.updateName(name)

    const email = fields.email
    this.updateEmail(email)

    // const option = fields.option
    // this.updateOption(option)

    const valid = /* name.valid && */ email.valid /* && option.valid */

    this.setState({ valid, fields })
  }, 150, { trailing: true })

  // updateName = (name) => {
  //   const name_value = trim(name.value)

  //   if (validator.isEmpty(name_value)) {
  //     name.error = 'Name is required.'
  //     name.valid = false
  //   } else if (!validator.matches(name_value, /^[A-Za-z .,-]+$/)) {
  //     name.error = 'Letters only, please.'
  //     name.valid = false
  //   } else {
  //     name.error = '',
  //       name.valid = true
  //   }
  // }

  updateEmail = (email) => {
    const email_value = trim(email.value)

    if (!validator.isEmail(email_value)) {
      email.error = 'Please enter a valid email address.'
      email.valid = false
    } else {
      email.error = ''
      email.valid = true
    }
  }

  // updateOption = (option) => {
  //   const option_value = option.value

  //   if (find(about_form_options, (val) => (val.value == option.value)) === undefined) {
  //     option.error = 'The provided option is not valid.'
  //     option.valid = false
  //   } else {
  //     option.error = ''
  //     option.valid = true
  //   }
  // }

  showError = (errorText) => {
    this.setState({ showError: true, errorText })
  }

  closeError = () => {
    this.setState({ showError: false, submitting: false })
  }

  handleSubmit = () => {
    const { valid, submitting, submitted, fields } = this.state

    if (submitting) return

    const post_data = {
      // name: fields.name.value,
      email: fields.email.value,
      // option: fields.option.value
    }

    const url = `https://6m0xy2t3qg.execute-api.us-east-1.amazonaws.com/dev/mailsubs`
    const opts = {
      body: JSON.stringify(post_data),
      headers: {
        'content-type': 'application/json'
      },
      method: 'POST',
      mode: 'cors'
    }

    if (!submitted) {
      this.setState({ submitted: true })
    }

    if (!valid) {
      return
    } else {
      this.setState({ submitting: true })
    }

    fetch(url, opts)
      .then((resp) => {
        console.log('Fetch success: ' + JSON.stringify(resp))
        return resp.json();
      }, (err) => {
        console.log(JSON.stringify(err))
      })
      .then((json) => {
        console.log(json)
        if (json.status === 400) {
          console.log('error!')
          if (json.title === 'Member Exists') {
            this.showError('The email address is already registered.')
          } else {
            this.showError('Sorry, an error occurred while adding you to our mailing list.  Please try again later.')
          }
        }
        else if (json.statusCode === 200) {
          this.setState(cloneDeep(default_form_state))
          this.props.onComplete(true)
        }
      })
      .catch(() => this.setState(cloneDeep(default_form_state)))
  }

  render() {
    const { valid, submitting, submitted, showError, errorText, fields } = this.state
    const { /*name,*/ email/*, option*/ } = fields

    // const name_label = <ContactLabel label='Full Name' valid={!submitted || name.valid} error={name.error} />
    const email_label = <ContactLabel label='Email' valid={!submitted || email.valid} error={email.error} />
    // const option_label = <ContactLabel label='Tell Us About Yourself' valid={!submitted ||option.valid} error={option.error} />

    return (
      <Form onSubmit={this.handleSubmit}>
        <Segment style={{ backgroundColor: '#f2f2f2', borderWidth: '0' }}>
          <p>Where can we email you with product updates?</p>
          {/* <Form.Input label={name_label} name='name' value={name.value} onChange={this.handleChange} error={submitted && !name.valid} /> */}
          <Form.Input label={email_label} name='email' value={email.value} onChange={this.handleChange} error={submitted && !email.valid} />
          {/* <Form.Dropdown fluid selection label={option_label} placeholder='Select an option'
            options={about_form_options} name='option' value={option.value} onChange={this.handleChange} error={submitted && !option.valid} /> */}
        </Segment>
        <Container textAlign='center'>
          <Form.Button
            type='submit' color='yellow' style={{ width: '10rem', height: '3rem' }}
            disabled={!valid && submitted && !submitting} loading={submitting}>Submit</Form.Button>
        </Container>
        <Modal dimmer='blurring' open={showError}
          content={errorText}
          actions={[
            { key: 'ok', content: 'OK', negative: true }
          ]}
          onClose={this.closeError} />
      </Form>
    )
  }
}

const twitter_url = 'https://twitter.com/Closet_Minimal'
const instagram_url = 'https://www.instagram.com/closet_minimal'

const ContactFormView = ({ onComplete, show }) => (
  <div style={show ? {} : { display: 'none' }}>
    <Grid columns={1}>
      <Grid.Row>
        <PageColumn>
          <Container text textAlign='left'>
            <p>Be the first to know when our clothes are available for your closet.
            Follow us on <a href={twitter_url}>Twitter</a> and <a href={instagram_url}>Instagram</a> for 
            news and tips.</p>
          </Container>
        </PageColumn>
      </Grid.Row>
      <Grid.Row>
        <PageColumn>
          <Container text>
            <p style={{ fontSize: '1.5rem' }}>Keep in Touch</p>
            <ContactForm onComplete={onComplete} />
          </Container>
        </PageColumn>
      </Grid.Row>
    </Grid>
  </div>
)

const blog_url = 'https://medium.com/closet-minimal'

const SubscribedView = ({ show }) => (
  <div style={show ? {} : { display: 'none' }}>
    <Grid columns={1}>
      <Grid.Row>
        <PageColumn>
          <Container text textAlign='left'>
            <Header>Nice to meet you!</Header>
            <p>We've added you to our mailing list.</p>
            <p>Want to start simplifying your life now? Read about uniforms
              and closet cleanout tips on our blog.</p>
          </Container>
        </PageColumn>
      </Grid.Row>
      <Grid.Row>
        <PageColumn>
          <Container text textAlign='center'>
            <a href={blog_url}><Button color='yellow' style={{ width: '10rem', height: '3rem' }}>Read Our Blog</Button></a>
          </Container>
        </PageColumn>
      </Grid.Row>
    </Grid>
  </div>
)


class ContactPage extends Component {
  state = { completed: false }

  setCompleted = (completed) => {
    this.setState({ completed })
  }

  render() {
    const { completed } = this.state

    return (
      <div>
        <ContactFormView onComplete={this.setCompleted.bind(this)} show={!completed} />
        <SubscribedView show={completed} />
      </div>
    )
  }
}

export default ContactPage



// WEBPACK FOOTER //
// ./src/pages/contact.js